export default () => (
  <svg width="18" height="18" viewBox="0 0 20 20" fill="none">
    <path
      fill="currentColor"
      d="M14.5385 0C15.0462 0 15.4615 0.410127 15.4615 0.911392V1.82278L15.6284 1.82818C16.9526 1.91413 18 3.01537 18 4.36125V15C18 17.2091 16.2091 19 14 19H4C1.79086 19 0 17.2091 0 15V4.36125C0 2.95929 1.13651 1.82278 2.53846 1.82278V0.911392C2.53846 0.410127 2.95385 0 3.46154 0C3.96923 0 4.38462 0.410127 4.38462 0.911392V1.82278H13.6154V0.911392C13.6154 0.410127 14.0308 0 14.5385 0ZM16 5H2V15C2 16.1046 2.89543 17 4 17H14C15.1046 17 16 16.1046 16 15V5Z"
    />
  </svg>
);
